import { IAppointment, IAppointmentCancellationForm, ILocation, IOrganizer } from 'capability-ng-appointments';
import * as _4 from 'lodash4';

export interface IAppointmentInformation {
  timeDetails: string;
  location: string;
  additionalDetails: string;
  comments: string;
  service: string;
  type: string;
  meetingURLOrPhone: string;
}

export class AppointmentInfoController {
  private appointmentInfo: IAppointmentInformation;
  private appointment: IAppointment;
  private isSyncedToCalendar: boolean;
  private addToCalendarCallbck: any;

  $onInit(): void {
    this.appointmentInfo = this._generateAppointmentInformation();
  }
  addToCalendar() {
    this.addToCalendarCallbck();
  }

  isPhoneNumber(rawLink: string) {
    return /^\d/g.test(rawLink);
  }

  generateWhy(appointment: IAppointment) {
    const service = _4.map(appointment.student_services, 'name').join(', ');
    return appointment.course ? `${service} ${appointment.course}` : service;
  }

  _generateAppointmentInformation(): IAppointmentInformation {
    const startTimestamp = moment.unix(this.appointment.start_timestamp);
    const date = `${startTimestamp.format('ddd MMM DD')} at ${startTimestamp.format('hh:mm a')}`;
    const organizerName: string = _4
      .map(this.appointment.organizers, (organizer: IOrganizer) => `${organizer.first_name} ${organizer.last_name}`)
      .join(', ');
    const organizerString =
      this.appointment.attendees.length > 1
        ? `${organizerName} + ${this.appointment.attendees.length - 1} more`
        : organizerName;
    const location = this.appointment.location.name;
    const additionalDetails: string = this.appointment.additional_details;
    const comments: string = this.appointment.comments;
    const service: string = this.generateWhy(this.appointment);
    const type: string = this.appointment.appointment_type;
    const meetingURLOrPhone: string = _4.get(this.appointment, 'meeting_url_or_phone', '');
    return {
      timeDetails: `${date} with ${organizerString}`,
      location,
      additionalDetails,
      comments,
      service,
      type,
      meetingURLOrPhone
    };
  }
}

export class AppointmentInfoComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/appointment_info/appointment_info.html';
  public controller: any = AppointmentInfoController;
  public bindings: any = {
    appointment: '<',
    isSyncedToCalendar: '<?',
    addToCalendarCallbck: '&?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/appointment_info/appointment_info.ts